class HomeAbout {
  constructor(section) {
    this.section = section;
    if (!this.section) return;

    this.swiperImageEl = this.section.querySelector('.swiper-image');
    this.swiperTextEl = this.section.querySelector('.swiper-text');
    
		if (!this.swiperImageEl || !this.swiperTextEl || typeof Swiper === 'undefined') return;
    
    this.init();
  }
  
  init() {
    let swiperOpts = {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        enabled: false,
        nextEl: this.section.querySelector('.swiper-button-next'),
        prevEl: this.section.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: false,
        el: this.section.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: (index, className) => {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      }
    }

    if (this.swiperTextEl.dataset.swiperAutoplay) {
      swiperOpts.autoplay = {
        delay: Number(this.swiperTextEl.dataset.swiperAutoplay),
        disableOnInteraction: false
      };
    }

    this.swiperImage = new Swiper(this.swiperImageEl, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      speed: 800
    });

    this.swiperText = new Swiper(this.swiperTextEl, swiperOpts);

    if (this.swiperText.controller && this.swiperImage.controller) {
      this.swiperText.controller.control = this.swiperImage;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-about').forEach(section => {
    new HomeAbout(section);
  });
});